import React, { useState, useRef, useEffect } from "react"
import "./single-dropdown.css"
import { NotificationPayload, PubSub, TopicsEnum } from "../../../src/utils/pubsub"

interface MenuItem {
  label?: string
  icon?: string // optional, always shown on the left
  isDivider?: boolean
  isDestructive?: boolean
  action?: () => void
}

interface SingleDropdownProps {
  triggerText: string
  triggerIcon?: React.ReactNode
  triggerIconPosition?: 'left' | 'right'
  align?: string
  menuItems: MenuItem[]
}

const SingleDropdown: React.FC<SingleDropdownProps> = ({
  triggerText,
  triggerIcon,
  triggerIconPosition = 'left',
  menuItems,
  align = 'left',
}) => {
  const [isOpen, setIsOpen] = useState(false)
  const menuRef = useRef<HTMLDivElement>(null)
  const [selectedLabel, setSelectedLabel] = useState<string>(triggerText)


  // Close on click outside
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (menuRef.current && !menuRef.current.contains(event.target as Node)) {
        setIsOpen(false);
      }
    };

    if (isOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOpen]);
  




  return (
    <div id="singleDropdown" className="single-dropdown-menu-new" ref={menuRef}>
      <button className="single-dropdown-trigger" onClick={() => setIsOpen(!isOpen)}>
        {triggerIcon && triggerIconPosition === "left" && (
          <span className={`trigger-icon left ${isOpen ? 'open' : ''}`}>{triggerIcon}</span>
        )}
        <span>{selectedLabel}</span>
        {triggerIcon && triggerIconPosition === "right" && (
           <span className={`trigger-icon right ${isOpen ? 'open' : ''}`}>{triggerIcon}</span>
        )}
      </button>

      {isOpen && (
        <div className={`single-dropdown-content ${align === 'left' ? 'left' : ''}`}>
          {menuItems.map((item, index) =>
            item.isDivider ? (
              <div key={`divider-${index}`} className="single-dropdown-separator"></div>
            ) : (
              <button
                key={item.label || `item-${index}`}
                className={`single-dropdown-item ${item.isDestructive ? "single-dropdown-item-destructive" : ""} ${
                    selectedLabel === item.label ? "selected" : ""
                }`}
                disabled={selectedLabel === item.label} // disable button if selected
                onClick={() => {
                    if (selectedLabel !== item.label) { // only allow if not selected
                    setSelectedLabel(item.label || triggerText)
                    item.action?.()
                    setIsOpen(false)
                    }
                }}
                >
                {item.icon && (
                    <img
                    src={item.icon}
                    alt={item.label}
                    width={16}
                    height={16}
                    className="single-dropdown-item-icon left"
                    />
                )}
                <span>{item.label}</span>
                </button>
            )
          )}
        </div>
      )}
    </div>
  )
}

export default SingleDropdown
